import { POINT } from '../../../constants/HydrometryConstants'
import i18n from 'simple-react-i18n'
import { hasValue } from '../../../../utils/NumberUtil'
import { getQualificationColor, getStatusIcon } from '../../../../utils/AnalyseUtils'
import { arrayOf, getLabel } from '../../../../utils/StoreUtils'
import { getSandreLabel } from '../../../../utils/StringUtil'
import { SANDRE } from '../../../../referencial/constants/ReferencialConstants'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { getColorCircleElement, getRGBColor } from '../../../../utils/ColorUtil'
import { getQualificationSelectOptions, getStatusSelectOptions } from '../../../../utils/StatusUtil'
import PropTypes from 'prop-types'
import DtoHydroMeasure from '../../../dto/chronicMeasures/DtoHydroMeasure'
import { getDate, getFullDate } from '../../../../utils/DateUtil'
import DtoJobExecution from '../../../../import/dto/DtoJobExecution'
import DtoJob from '../../../../import/dto/DtoJob'
import JobAction from '../../../../import/actions/JobAction'
import { Grid } from '@mui/material'
import { push } from '@lagunovsky/redux-react-router'
import { IS_INITIAL_POINT } from 'station/constants/StationConstants'

const DescriptionMeasure = ({
    selection,
    measure,
}) => {
    const {
        sandreCodes,
        contributors,
    } = useSelector(store => ({
        sandreCodes: store.ReferencialReducer.sandreCodes,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const [job, setJob] = useState({})
    const dispatch = useDispatch()

    useEffect(() => {
        if (measure?.jobExecutionId) {
            dispatch(JobAction.getJobByJobExecutionId(measure.jobExecutionId)).then(res => {
                setJob(res)
            })
        }
    }, [measure])

    const statusList = getStatusSelectOptions()
    const qualificationsList = getQualificationSelectOptions()

    const color = measure ? getQualificationColor(measure.qualification) : ''
    const colorQualification = measure ? getRGBColor(color) : ''
    const getColorCircle = measure ? getColorCircleElement(colorQualification, true) : ''

    return (
        <Grid container sx={{ paddingLeft: '10px' }}>
            <Grid size={12}>
                <h6 className='bold'>
                    { selection === POINT ? i18n.selectedMeasureDetails : i18n.firstMeasureDetails }
                </h6>
            </Grid>
            { measure.updateDate && measure.updateLogin && <Grid size={12}>{ `${i18n.updatedOn + getDate(measure.updateDate)} ${i18n.by} ${measure.updateLogin}` }</Grid> }
            <Grid size={12} container>
                { hasValue(measure.status) && <Grid size={6}>{ getStatusIcon(measure.status, status) }{ getLabel(statusList, measure.status) }</Grid> }
                { hasValue(measure.qualification) && <Grid size={6}>{ getColorCircle }{ getLabel(qualificationsList, measure.qualification) }</Grid> }
            </Grid>
            <Grid size={12}>
                { hasValue(measure.nature) && <Grid size={6}>{ (`${i18n.nature} : ${getSandreLabel(sandreCodes, SANDRE.PIEZOMETER_MEASURE_NATURE, measure.nature)}`) }</Grid> }
                { hasValue(measure.producer) && <Grid size={6}>{ (`${i18n.producer} : ${getLabel(contributors, measure.producer, 'mnemonique')}`) }</Grid> }
            </Grid>
            <Grid size={12}>
                { hasValue(measure.initialPoint) && <Grid size={6}>{ `${i18n.initialPoint} : ${measure.initialPoint === IS_INITIAL_POINT ? i18n.yes : i18n.no}` }</Grid> }
            </Grid>
            <Grid size={12}>
                { hasValue(measure.manager) && <Grid size={6}>{ (`${i18n.administrator} : ${getLabel(contributors, measure.manager, 'mnemonique')}`) }</Grid> }
                { hasValue(measure.validator) && <Grid size={6}>{ (`${i18n.validator} : ${getLabel(contributors, measure.validator, 'mnemonique')}`) }</Grid> }
            </Grid>
            <Grid size={12}>
                { hasValue(measure.value) && <Grid size={6}>{ (`${i18n.value} : ${measure.value}`) }</Grid> }
            </Grid>
            { measure.importDate && <Grid size={12}>{ `${i18n.createdOn} ${getFullDate(measure.importDate)}` }</Grid> }
            { job && <Grid size={12} sx={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => dispatch(push(`/import/${job.id}?jobExecutionId=${measure.jobExecutionId}`))}>{ `${i18n.importName} : ${job.name || ''} ${job.login || ''} [${measure.jobExecutionId}]`}</Grid> }
            { !job && measure.jobExecutionId && <Grid size={12}>{ i18n.jobDoesNotExistAnymore }</Grid> }
        </Grid>
    )
}
DescriptionMeasure.propTypes = {
    jobs: arrayOf(DtoJob),
    jobExecutions: arrayOf(DtoJobExecution),
    selection: PropTypes.string,
    measure: PropTypes.instanceOf(DtoHydroMeasure),
}
export default DescriptionMeasure